import { __extends } from "tslib";
import * as React from 'react';
import Add from 'wix-ui-icons-common/Add';
import { PreviewMode } from '../preview-elements/preview-context';
import { Box, TextButton } from 'wix-style-react';
import { composer } from '../../../component-decorators/composer';
var TagBoxPreviewWrapper = /** @class */ (function (_super) {
    __extends(TagBoxPreviewWrapper, _super);
    function TagBoxPreviewWrapper(props) {
        return _super.call(this, props) || this;
    }
    TagBoxPreviewWrapper.prototype.render = function () {
        var _this = this;
        return (React.createElement(PreviewMode.Consumer, null, function (value) {
            return value.isPreview &&
                !(_this.props.tags && _this.props.tags.length > 0) ? (React.createElement(Box, { direction: "vertical" },
                React.createElement(TextButton, { prefixIcon: React.createElement(Add, null), as: "a", href: "https://dev.wix.com/dc3/my-apps/" + value.appId + "/market/info/basic-info", target: "_blank" },
                    React.createElement(TranslatedKey, { tkey: 'solution.page.preview.addSearchKeys' })))) : (_this.props.children);
        }));
    };
    return TagBoxPreviewWrapper;
}(React.Component));
export { TagBoxPreviewWrapper };
var TranslatedKey = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, tkey = _a.tkey;
    return t(tkey);
});
//# sourceMappingURL=tags-box-content.js.map